 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"banners~campaigns~categories~clips~courses~courses-categories~exercises~exercises-items~reports~videos":"banners~campaigns~categories~clips~courses~courses-categories~exercises~exercises-items~reports~videos","reports":"reports","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details","admin":"admin","campaigns-send":"campaigns-send","categories-create":"categories-create","categories-details":"categories-details","exercises-items-create":"exercises-items-create","exercises-items-details":"exercises-items-details","course-categories-create":"course-categories-create","course-categories-details":"course-categories-details","videos-create~videos-details":"videos-create~videos-details","videos-create":"videos-create","videos-details":"videos-details","banners":"banners","campaigns":"campaigns","categories":"categories","clips":"clips","courses":"courses","courses-categories":"courses-categories","exercises":"exercises","exercises-items":"exercises-items","videos":"videos","banner-create":"banner-create","banner-details":"banner-details","courses-create":"courses-create","courses-details":"courses-details","exercises-create":"exercises-create","exercises-details":"exercises-details","users":"users","push-notification":"push-notification","auth":"auth","dashboard":"dashboard","home":"home","content":"content","inbox":"inbox"}[chunkId]||chunkId) + "." + {"chunk-748fc7ec":"62df1c34","banners~campaigns~categories~clips~courses~courses-categories~exercises~exercises-items~reports~videos":"9e8d0218","reports":"e1fda33a","chunk-75a8b168":"80e05ec2","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"d2f285b4","admin":"c2ea7500","campaigns-send":"8b17626c","categories-create":"40b363fd","categories-details":"37f4fb2a","exercises-items-create":"78cabdf9","exercises-items-details":"c38de8df","course-categories-create":"43277e47","course-categories-details":"2a2f7599","videos-create~videos-details":"26930f8d","videos-create":"10d92483","videos-details":"8c990eb7","chunk-d078829c":"1006961f","chunk-24a08e14":"ff2b3456","banners":"6b6283dd","campaigns":"f2cb434e","categories":"3785d8b1","clips":"80d0a876","courses":"e6416e91","courses-categories":"c76fa7aa","exercises":"f894da9c","exercises-items":"40e01aa8","videos":"d6e9dcf9","banner-create":"2b1c6ff3","banner-details":"3005f7ce","chunk-390f72f0":"7056ca9f","chunk-76196ad2":"4c950d5d","courses-create":"874ab8a1","courses-details":"4770e3ef","exercises-create":"3c594ec0","exercises-details":"286a7ab3","users":"56607edb","push-notification":"86d3ac7d","auth":"e1858126","dashboard":"6571b096","home":"674c3f30","content":"c153eb38","inbox":"c212d76f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-748fc7ec":1,"banners~campaigns~categories~clips~courses~courses-categories~exercises~exercises-items~reports~videos":1,"reports":1,"admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":1,"admin":1,"campaigns-send":1,"categories-create":1,"categories-details":1,"exercises-items-create":1,"exercises-items-details":1,"course-categories-create":1,"course-categories-details":1,"videos-create~videos-details":1,"videos-create":1,"chunk-d078829c":1,"chunk-24a08e14":1,"banners":1,"campaigns":1,"categories":1,"clips":1,"courses":1,"courses-categories":1,"exercises":1,"exercises-items":1,"videos":1,"banner-create":1,"banner-details":1,"chunk-390f72f0":1,"chunk-76196ad2":1,"courses-create":1,"courses-details":1,"exercises-create":1,"exercises-details":1,"users":1,"push-notification":1,"auth":1,"dashboard":1,"home":1,"content":1,"inbox":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"banners~campaigns~categories~clips~courses~courses-categories~exercises~exercises-items~reports~videos":"banners~campaigns~categories~clips~courses~courses-categories~exercises~exercises-items~reports~videos","reports":"reports","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details","admin":"admin","campaigns-send":"campaigns-send","categories-create":"categories-create","categories-details":"categories-details","exercises-items-create":"exercises-items-create","exercises-items-details":"exercises-items-details","course-categories-create":"course-categories-create","course-categories-details":"course-categories-details","videos-create~videos-details":"videos-create~videos-details","videos-create":"videos-create","videos-details":"videos-details","banners":"banners","campaigns":"campaigns","categories":"categories","clips":"clips","courses":"courses","courses-categories":"courses-categories","exercises":"exercises","exercises-items":"exercises-items","videos":"videos","banner-create":"banner-create","banner-details":"banner-details","courses-create":"courses-create","courses-details":"courses-details","exercises-create":"exercises-create","exercises-details":"exercises-details","users":"users","push-notification":"push-notification","auth":"auth","dashboard":"dashboard","home":"home","content":"content","inbox":"inbox"}[chunkId]||chunkId) + "." + {"chunk-748fc7ec":"fbb07054","banners~campaigns~categories~clips~courses~courses-categories~exercises~exercises-items~reports~videos":"aa7c79be","reports":"496db9ee","chunk-75a8b168":"31d6cfe0","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"970a5d5c","admin":"064b4f0c","campaigns-send":"97da87a9","categories-create":"7149e40b","categories-details":"7149e40b","exercises-items-create":"f31c1f45","exercises-items-details":"f31c1f45","course-categories-create":"d1324a86","course-categories-details":"d1324a86","videos-create~videos-details":"7ef8a0e2","videos-create":"f31c1f45","videos-details":"31d6cfe0","chunk-d078829c":"762f64c7","chunk-24a08e14":"bd63b956","banners":"e2d720fd","campaigns":"261192c6","categories":"e2d720fd","clips":"e2d720fd","courses":"e2d720fd","courses-categories":"e2d720fd","exercises":"e2d720fd","exercises-items":"e2d720fd","videos":"e2d720fd","banner-create":"7805aca0","banner-details":"7805aca0","chunk-390f72f0":"f76447a3","chunk-76196ad2":"f76447a3","courses-create":"b89b032a","courses-details":"b89b032a","exercises-create":"5ac9c5c9","exercises-details":"5ac9c5c9","users":"cf95d952","push-notification":"f31c1f45","auth":"7f1a5d5f","dashboard":"612df520","home":"c1501988","content":"2210d6e4","inbox":"69d476e5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
